import {
  VideoTestimonialCardV2,
  VideoTestimonialCardV2Props as VideoTestimonialCardV2ComponentProps,
} from "@kunduz/feature-landing-pages";
import { ComponentConfig } from "@measured/puck";

export interface VideoTestimonialCardProps
  extends VideoTestimonialCardV2ComponentProps {}

const TestimonialCard = (props: VideoTestimonialCardProps) => {
  return <VideoTestimonialCardV2 {...props} />;
};

export const PuckvideoTestimonialCard: ComponentConfig<VideoTestimonialCardProps> =
  {
    label: "Video Testimonial Card",
    fields: {
      videoUrl: { type: "text", label: "Video URL" },
      wistiaId: { type: "text", label: "Wistia ID" },
      desc: { type: "text", label: "Description" },
      thumbnail: { type: "text", label: "Thumbnail URL" },
      title: { type: "text", label: "Title" },
    },
    defaultProps: {
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      thumbnail: "https://example.com/thumbnail.jpg",
      videoUrl: "https://staging-cdn.kunduzapp.com/cms/media/beaver-video.mp4",
      title: "Testimonial Title",
    },
    render: (props) => <TestimonialCard {...props} />,
  };
